import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { getFormPdf } from 'actions';

import NotFoundPage from 'components/Errors/NotFoundPage';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class OriginalPdfForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape().isRequired,
    isFetchingPdfForm: PropTypes.bool,
    // eslint-disable-next-line
    pdfData: PropTypes.any,
    getFormPdfError: PropTypes.shape({})
  };

  static defaultProps = {
    isFetchingPdfForm: false,
    pdfData: null,
    getFormPdfError: null
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params: { formId } } = match;
    dispatch(getFormPdf(formId));
  }

  render() {
    const {
      isFetchingPdfForm,
      pdfData,
      getFormPdfError
    } = this.props;
    return (
      <div className="original-pdf-form">
        { !getFormPdfError && pdfData != null && <div className="progress-wrapper">
          {
            // eslint-disable-next-line
            isFetchingPdfForm
              ? <progress className="progress" max="100" />
              : <object
                data={ pdfData }
                type="application/pdf"
                width="100%"
                height="100%"
              >
                Cannot display inline PDF document. Try to
                <a href={ pdfData } download>download</a>
                it
              </object>
          }
        </div> }
        { getFormPdfError && <div className="page">
          <div className="page-body">
            <NotFoundPage caption="The PDF form was not found" />
          </div>
        </div> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isFetchingPdfForm,
    pdfData,
    getFormPdfError
  } } = state;
  return {
    isFetchingPdfForm,
    pdfData,
    getFormPdfError
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(OriginalPdfForm, 'OriginalPdfForm'));
